__turbopack_context__.v({
  "container": "FaqTabUpdated-module-scss-module__2KXjeG__container",
  "faqGridItem": "FaqTabUpdated-module-scss-module__2KXjeG__faqGridItem",
  "image": "FaqTabUpdated-module-scss-module__2KXjeG__image",
  "title": "FaqTabUpdated-module-scss-module__2KXjeG__title",
});
